export const EVA_AVATAR_IMAGE = '/icons/mcgkl0smwebaplarrgju.png';
